module.exports = __webpack_public_path__ + "img/test5.aa4a6e49.png";